export default __webpack_public_path__ + "34fab767ab0e378a0e7dcabba59d246f.png";